import { Injectable, inject } from '@angular/core'
import { BvAlertService } from '@ziptility/bv-alert'
import { AccountAPIService, UserAPIService } from '@modules/bv-api'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import { State } from '..'
import { DialogService } from '../../components/dialogs'
import * as UserActions from './actions'

@Injectable()
export class UserEffects {
  readonly store = inject(Store<State>)
  readonly actions$ = inject(Actions)
  readonly userService = inject(UserAPIService)
  readonly accountAPIService = inject(AccountAPIService)
  readonly dialogService = inject(DialogService)
  readonly bvAlertService = inject(BvAlertService)

  UpdateEmailNotificationsRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.updateNotificationPreference),
      switchMap((payload) => {
        const { notificationPreferenceIds } = payload
        return this.accountAPIService.updateNotificationPreference(notificationPreferenceIds).pipe(
          switchMap((response) => {
            this.bvAlertService.success(`Notification settings where updated successfully.`)
            return of(UserActions.updateNotificationPreferenceSuccess({ response }))
          }),
          catchError((error: any) => of(UserActions.updateNotificationPreferenceError({ error }))),
        )
      }),
    ),
  )

  UserSignUp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.signUp),
      switchMap((data) => {
        return this.userService.signUp(data).pipe(
          map((response) => {
            // show welcome dialog
            this.dialogService.welcomeDialog()
            return UserActions.signUpSuccess({ response })
          }),
          catchError((error: any) => of(UserActions.signUpError({ error }))),
        )
      }),
    ),
  )
}
